import React from 'react';
import PropTypes from 'prop-types';

/**
 * PageList - A wrapper that renders a standard HTML ul with Bulma class names
 *
 * This component accepts the same props as Bloomer PageList for easy migration
 */
const PageList = ({ className, children, style, ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['pagination-list'];

    // Add custom class names
    if (className) {
      classes.push(className);
    }

    return classes.join(' ');
  };

  return (
    <ul className={getClassNames()} style={style} {...props}>
      {children}
    </ul>
  );
};

PageList.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

PageList.defaultProps = {
  className: '',
  style: {},
  children: null,
};

export default PageList;
